function getSession() {
    const token = JSON.parse(sessionStorage.getItem("token"));
    const cbid = JSON.parse(sessionStorage.getItem("cbid"));
    return { token, cbid };
}

export async function getUser() {
    const browserData = getSession();
    const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${browserData.token}` }
    };
    console.log("Token:", browserData.token);
    console.log("User ID:", browserData.cbid);
    const response = await fetch(`${process.env.REACT_APP_HOST}/api/users/${browserData.cbid}`, requestOptions);
    console.log(browserData.cbid)
    if (!response.ok) {
        throw new Error(`Error: ${response.statusText} (status: ${response.status})`);
    }
    const data = await response.json();
    return data;
}

export async function getUserOrders() {
    const browserData = getSession();
    if (!browserData.cbid) {
        throw new Error("User ID is missing from session");
    }

    const requestOptions = {
        method: "GET",
        headers: { 
            "Content-Type": "application/json", 
            Authorization: `Bearer ${browserData.token}` 
        }
    };
    const response = await fetch(`${process.env.REACT_APP_HOST}/api/orders?userId=${browserData.cbid}`, requestOptions);
    if (!response.ok) {
        throw new Error(`Error: ${response.statusText} (status: ${response.status})`);
    }
    const data = await response.json();
    return data;
}

export async function createOrder(cartList, total, user) {
    const browserData = getSession(); // Pretpostavlja se da dobijaš sesiju korisnika
    const order = {
        cartList: cartList.map(item => ({
            productName: item.name,
            price: item.price
        })),
        amount: total,
        quantity: cartList.length,
        user: {
            name: user.name,
            email: user.email
        }
    };
    
    const requestOptions = {
        method: "POST",
        headers: { 
            "Content-Type": "application/json",
            Authorization: `Bearer ${browserData.token}` 
        },
        body: JSON.stringify(order)
    };
    const response = await fetch(`${process.env.REACT_APP_HOST}/api/orders`, requestOptions);
    if (!response.ok) {
        throw new Error(`Error: ${response.statusText} (status: ${response.status})`);
    }
    const data = await response.json();
    return data;
}
